function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".factory_stroke{fill:none;stroke:currentColor;stroke-width:2;stroke-miterlimit:10;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "assets"
}, /*#__PURE__*/React.createElement("g", {
  id: "factory"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "factory_fill",
  points: ".5 20.5 19.17 32.5 19.17 20.5 37.83 32.5 37.83 20.5 56.5 32.5 56.5 .5 64.5 .5 64.5 56.5 .5 56.5 .5 20.5"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "factory_stroke",
  points: ".5 20.5 19.17 32.5 19.17 20.5 37.83 32.5 37.83 20.5 56.5 32.5 56.5 .5 64.5 .5 64.5 56.5 .5 56.5 .5 20.5"
})));

var SvgFactory = function SvgFactory(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "factoryIcon",
    viewBox: "-2 -2 69 61",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFactory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/factory.8ff6e2b8.svg";
export { ForwardRef as ReactComponent };